<template>
  <div class="flex flex-wrap items-start gap-1">
    <app-chip
      v-if="formattedTime || session.is_online"
      class="bg-gray-50"
      size="small"
      to="#program"
    >
      <template v-if="formattedTime">
        {{ formattedTime }}
      </template>

      <template v-else>
        {{ $t("course.format.online_label") }} ({{ courseFormatLabel }})
      </template>
    </app-chip>

    <place-overview v-if="session.place" :place="session.place">
      <app-chip
        append-icon="ph:info"
        class="bg-gray-50"
        data-cy-session-address
        size="small"
      >
        {{ session.place.address.city }},
        {{ session.place.address.zip_code }}
      </app-chip>
    </place-overview>
    <course-online-type-chip
      v-if="session.is_online"
      class="bg-gray-50 !text-black"
      size="small"
    />

    <slot name="append" />
  </div>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import PlaceOverview from "~/business-areas/place/components/place-overview.vue";

const properties = defineProps<{
  course: CoursePageView;
  session: CourseSessionView;
}>();

const courseFormatLabel = useCourseFormatLabel(properties.course.format);
const { formattedTime } = useCourseSessionInfo(properties.session);
</script>
